@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.address-validated {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: -5px;
  font-size: 12px;

  svg {
    color: @address-validation--validated--fill-color;
  }

  .validated {
    flex: 1;
    color: @address-validation--validated--text-color;
  }
}

.not-validated {
  margin-top: 5px;
}

.message {
  flex: 1;
  font-size: 12px;
  min-width: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  line-height: 16px;
}

.validation-issue {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: -5px;
  min-width: 0;
}

.error {
  svg {
    color: @address-validation--error--fill-color;
  }

  .message {
    color: @address-validation--message--error--text-color;
  }
}

.warning {
  svg {
    color: @address-validation--warning--fill-color;
  }

  .message {
    color: @address-validation--message--warning--text-color;
  }
}

.validate-links {
  display: flex;
  height: 30px;
}

.revert-address,
.revalidate-address {
  padding-left: 10px;
  margin-left: 2px;
  align-self: center;
  button {
    font-size: 12px;
  }
}
